<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/frameworks/web-awesome']" appearance="plain" variant="neutral">&larr; Back to Web Awesome</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>WaPageSkipToContent</h1>
		</div>
		<p waBody="m" waColorText="quiet" waText>Accessibility skip-to-content link that appears on keyboard focus for screen reader users.</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_413" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<div waCaption="s" waFontWeight="semibold" waText>CONSTRUCTORS</div>
				<markdown [data]="mdContent_414" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates a wa-page-skip-to-content element</p>
			</div>
		</wa-details>
	</div>
</div>